export enum QualifiedPlanType {
    Qualified = "qualified",
    NonQualified = "non-qualified"
}
